import type { AdapterLogo } from "../agent-adapter.ts";
import { cx } from "../ui.tsx";

/** A fixed 20px square, in px not rem (the app's root font size is 14px, so size-5 is 17.5px): never
 *  shrunk by the flex row or Tailwind's img max-width, never stretched. */
const MARK = "size-[20px] min-h-[20px] min-w-[20px] max-w-none shrink-0 object-contain";

/** An adapter's official mark at 20px, on a paper chip so the theme-matched variant reads in both the
 *  selected (ink) and unselected states. A mark with a dark variant renders both; styles.css shows the
 *  one that matches the current theme. */
export function AdapterLogoMark({ logo }: { logo: AdapterLogo }) {
  return (
    <span className="inline-flex shrink-0 items-center justify-center rounded-md bg-paper p-0.5" data-testid="adapter-logo">
      <img src={logo.light} alt={logo.name} width={20} height={20} data-variant={logo.dark ? "light" : undefined} className={cx(MARK, logo.dark && "adapter-logo-light")} />
      {logo.dark && <img src={logo.dark} alt={logo.name} width={20} height={20} data-variant="dark" className={cx(MARK, "adapter-logo-dark")} />}
    </span>
  );
}
